module.exports = __webpack_public_path__ + "img/J12809.180bbb81.png";